import {
  ParticipantContextIfNeeded,
  TrackRefContext,
  VideoTrack,
} from "@livekit/components-react";
import cameraPopup from "../../../components/Actions/img/camera-popup.svg";
import styles from "./StudioCanvas.module.css";
import { StudioCanvasProps } from "./StudioCanvas.interface";

const StudioCanvas = ({ trackRef }: StudioCanvasProps) => {
  return (
    <TrackRefContext.Provider value={trackRef}>
      <ParticipantContextIfNeeded participant={trackRef?.participant}>
        {trackRef ? (
          <div>
            <VideoTrack
              trackRef={trackRef}
              className={styles["studio-canvas__camera"]}
            />
          </div>
        ) : (
          <div className={styles["studio-canvas__container"]}>
            <img
              className={styles["studio-canvas__video-image"]}
              src={cameraPopup}
              alt="Предпросмотр видео"
            />
          </div>
        )}
      </ParticipantContextIfNeeded>
    </TrackRefContext.Provider>
  );
};

export default StudioCanvas;
